"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../constants");
const constants_2 = require("./constants");
exports.default = theme => {
    const backgroundColor = theme.grey8;
    return {
        '@global': {
            ':root': {
                backgroundColor,
                position: 'fixed',
                zIndex: constants_1.HTMLROOT_FIXED_ZINDEX,
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                overflow: 'hidden'
            },
            body: {
                backgroundColor: 'inherit',
                margin: 0,
                height: '100%',
                width: '100%'
            },
            '#root': {
                backgroundColor: 'inherit',
                width: 'inherit',
                height: 'inherit'
            }
        },
        root: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor,
            overflow: 'auto',
            '-webkit-font-smoothing': 'antialiased',
            '-moz-osx-font-smoothing': 'grayscale',
            '-webkit-text-size-adjust': '100%',
            '-webkit-overflow-scrolling': 'touch',
            paddingLeft: constants_2.ISOLATE_X_PADDING,
            paddingRight: constants_2.ISOLATE_X_PADDING
        }
    };
};
//# sourceMappingURL=isolate.style.js.map